































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import store from "@/store";
import { AccountApi, IUser, IUserUpdateData } from "@/core/account";

@Component({
	components: {
	},
})
export default class Account extends Vue {

	private get Rules(): { [name: string]: (v: any) => true | string } {
		return {
			AvatarSize: v => !v || !v.size || v.size < 5000000 || this.$tc("Avatar size should be less than 2 MB!"),
			Required: v => !!v || this.$tc("rule_required"),
		};
	}

	private get UserAvatar() { const u = this.User; return `/img/profile/${(this.User && this.User.ProfilePicture ? this.User.ProfilePicture : "ProfilePicture_null.png")}`; }
	public User: Partial<IUserUpdateData> = {};

	public isSaving: boolean = false;
	public isDirty: boolean = false;
	private api: AccountApi;

	public constructor() {
		super();
		this.api = new AccountApi();
	}

	@Watch("User", { deep: true })
	public onRegistrationChanged(val: Partial<IUserUpdateData>, oldVal: Partial<IUserUpdateData>) {
		this.isDirty = true;
	}

	public mounted() {
		this.LoadAccountData();
	}

	private async LoadAccountData() {
		this.User = await this.api.load();
		setTimeout(() => {
			this.isDirty = false;
		});
	}
	private async UpdateAccountData() {
		this.isSaving = true;

		await this.api.update(this.User);

		this.isDirty = false;
		this.isSaving = false;
		await this.LoadAccountData();
	}

	private RemoveAvatar() {
		this.User.ProfilePicture = null;
	}

	private async AvatarChanged(file: File): Promise<void> {
		return new Promise<void>((resolve, reject) => {
			if (file) {
				const a = this;
				const user = this.User;
				const fileReader = new FileReader();
				fileReader.onloadend = (ev) => {
					user.NewProfilePictureData = fileReader.result as string;
					a.isDirty = true;
					resolve();
				};
				fileReader.onerror = (e) => reject(e);
				fileReader.readAsDataURL(file);
			} else
				this.User.NewProfilePictureData = undefined;
		});
	}

}
